export const handleDynamicValidation = (values: any, formik: any) => {
  const errors = { ...formik.errors };

  // Main validation logic
  if (values.isCustodian) {
    const mailingErrors = validateMailingAddress(values?.mailingAddress);
    if (Object.keys(mailingErrors).length) {
      errors.mailingAddress = mailingErrors;
    }

    const custodianErrors = validateCustodianDetails(values?.custodianDetails);
    if (Object.keys(custodianErrors).length) {
      errors.custodianDetails = custodianErrors;
    }
  }

  if (values.isFacility && !values.facilityTypes?.length) {
    errors.facilityTypes = 'Facility type is required';
  }

  if (Object.keys(errors).length > 0) {
    formik.setErrors(errors);
    return false;
  }

  return true;
};

// Helper function to handle address validation
const validateMailingAddress = (mailingAddress: any) => {
  const mailingErrors: any = {};
  if (!mailingAddress?.addressDetails) {
    mailingErrors.addressDetails = 'Mailing address details are required';
  }
  if (!mailingAddress?.city) {
    mailingErrors.city = 'Mailing city is required';
  }
  if (!mailingAddress?.stateId) {
    mailingErrors.stateId = 'Mailing state is required';
  }
  if (!mailingAddress?.postCode) {
    mailingErrors.postCode = 'Mailing postal code is required';
  }
  return mailingErrors;
};

// Helper function to handle custodian validation
const validateCustodianDetails = (custodianDetails: any) => {
  const custodianErrors: any = {};
  if (!custodianDetails?.recordTypes?.length) {
    custodianErrors.recordTypes = 'At least one record type is required';
  }
  if (!custodianDetails?.orderTypeId) {
    custodianErrors.orderTypeId = 'Order type is required';
  }
  return custodianErrors;
};
